<svg
  width="25"
  height="25"
  viewBox="0 0 25 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.8982 6.81122C13.1347 5.52386 11.2257 5.52386 10.4621 6.81122L4.44892 16.9492C3.68534 18.2365 4.63982 19.8457 6.16698 19.8457H18.1934C19.7205 19.8457 20.675 18.2365 19.9114 16.9491L13.8982 6.81122ZM11.2212 10.0765C11.2032 9.54902 11.6376 9.11187 12.1799 9.11187C12.7223 9.11187 13.1569 9.5494 13.1385 10.0771L12.9974 14.1344C12.9825 14.5641 12.6202 14.905 12.1785 14.905C11.7365 14.905 11.3742 14.5638 11.3596 14.1339L11.2212 10.0765ZM13.2712 17.1966C13.2712 17.7831 12.7827 18.2586 12.1801 18.2586C11.5775 18.2586 11.089 17.7831 11.089 17.1966C11.089 16.61 11.5775 16.1345 12.1801 16.1345C12.7827 16.1345 13.2712 16.61 13.2712 17.1966Z"
    fill="#EAA601"
  />
</svg>
